import h, { Component as b } from "react";
import e from "prop-types";
import m from "classnames";
import './TextArea.css';const g = "TextArea-module__text_area___abZSP", _ = "TextArea-module__disabled___N09tP", s = {
  text_area: g,
  disabled: _
};
class r extends b {
  constructor() {
    super(), this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.props.focus && this.el.focus();
  }
  handleChange(a) {
    this.props.onChange(a.target.value);
  }
  render() {
    const {
      rows: a,
      value: t,
      placeholder: l,
      disabled: i,
      name: o,
      id: d,
      ariaDescribedBy: n,
      ariaLabelledBy: p,
      autoComplete: c
    } = this.props;
    return /* @__PURE__ */ h.createElement(
      "textarea",
      {
        id: d,
        "aria-describedby": n,
        "aria-labelledby": p,
        ref: (u) => {
          this.el = u;
        },
        name: o,
        autoComplete: c,
        className: m(s.text_area, this.props.className, {
          [s.disabled]: this.props.disabled
        }),
        rows: a,
        placeholder: l,
        value: t,
        disabled: i,
        onChange: this.handleChange
      }
    );
  }
}
r.propTypes = {
  /** class name */
  className: e.string,
  /** the function to be called on change (should change what is passed in for value). Returns what is typed in. */
  onChange: e.func.isRequired,
  /** the value of the textarea */
  value: e.string.isRequired,
  /** the placeholder text */
  placeholder: e.string,
  /** number of rows (height) */
  rows: e.number,
  /** Whether text area is disabled or not */
  disabled: e.bool,
  /** whether textarea should be focused on mount */
  focus: e.bool,
  /** the 'name' property of the text area */
  name: e.string,
  /** the 'id' property of the text area */
  id: e.string,
  /** HTML id of corresponding description for accessibility */
  ariaDescribedBy: e.string,
  /**
   * HTML id of corresponding label for accessibility.
   *
   * **Note:**
   * This should be set to ensure the component is
   * accessible and usable by assistive technologies.
   */
  ariaLabelledBy: e.string,
  /** HTML autocomplete token (e.g., "name", "email", "street-address", "new-password") */
  autoComplete: e.string
};
r.defaultProps = {
  className: void 0,
  rows: 6,
  disabled: !1,
  focus: !1,
  name: null,
  placeholder: "",
  id: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  autoComplete: void 0
};
export {
  r as T
};
